import { useSyncExternalStore } from 'react';
import { followMetricsStore, type FollowMetrics } from './followMetrics.js';

export function useFollowMetrics(): FollowMetrics | null {
  return useSyncExternalStore(
    followMetricsStore.subscribe,
    () => followMetricsStore.getState().metrics,
    () => null,
  );
}
